import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ConsentModalComponent } from './consent-modal.component'
import { I18nModule } from '@spartacus/core'
import { UcBlockedContentReplacerModule } from '../../uc-blocked-content-replacer/uc-blocked-content-replacer.module'

@NgModule({
  declarations: [
    ConsentModalComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    UcBlockedContentReplacerModule
  ],
  exports: [
    ConsentModalComponent
  ]
})
export class ConsentModalModule {}
